import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { DatePipe, JsonPipe, NgClass, NgForOf, NgIf, NgStyle, SlicePipe } from "@angular/common";
import {
  MedBtnModule, MedCheckboxModule, MedDatepickerModule, MedDirectiveSharedModule, MedInputModule,
  MedModalModule, MedMultiSelectModule,
  MedPaginationModule,
  MedRadioGroupModule, MedSwitchModule,
  MedTabGroupModule,
  MedTabModule,
} from "@mk/med-ui";
import { PaginatorModule } from "primeng/paginator";
import { DockModule } from "primeng/dock";
import {
  MedIconArrowRightModule, MedIconCalendarEditModule, MedIconCheckModule,
  MedIconChevronLeftModule,
  MedIconChevronRightModule, MedIconCircleSlashModule,
  MedIconCloseModule, MedIconEditModule, MedIconHistoryModule, MedIconRedoModule,
} from "@mk/med-icons";
import { OrganizationsComponent } from "@app/components/organizations/organizations.component";
import { ReservesComponent } from "@app/components/reserves/reserves.component";
import { SuppliesModule } from "@app/components/supplies/supplies.module";
import { RecipientsModule } from "@app/components/recipients/recipients.module";
import { BasketModule } from "@app/components/basket/basket.module";
import { DistributionModule } from "@app/components/distribution/distribution.module";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { LoaderModule } from "@app/components/loader/loader.module";
import { SidebarModule } from "primeng/sidebar";
import { DistributionDozModule } from "@app/components/distribution/doz/distributionDoz.module";
import { RefreshingComponent } from "@app/components/refreshing/refresh.component";
import { DistributionsMZUModule } from "@app/components/distributions/mzu/distributions.mzu.module";
import { DistributionsDozModule } from "@app/components/distributions/doz/distributions.doz.module";

@NgModule({
  declarations: [
    OrganizationsComponent,
    ReservesComponent,
    RefreshingComponent,
  ],
  imports: [
    SuppliesModule,
    RecipientsModule,
    MedBtnModule,
    NgForOf,
    TableModule,
    MedModalModule,
    MedModalModule,
    PaginatorModule,
    NgStyle,
    NgIf,
    PageTitleModule,
    SlicePipe,
    DockModule,
    MedPaginationModule,
    MedRadioGroupModule,
    MedTabGroupModule,
    MedTabModule,
    MedDirectiveSharedModule,
    MedSwitchModule,
    MedCheckboxModule,
    DatePipe,
    MedIconArrowRightModule,
    BasketModule,
    MedIconChevronRightModule,
    DistributionModule,
    MedIconChevronLeftModule,
    NgClass,
    LoaderModule,
    DistributionsMZUModule,
    DistributionsDozModule,
    MedDatepickerModule,
    MedIconCloseModule,
    MedIconHistoryModule,
    MedMultiSelectModule,
    SidebarModule,
    MedInputModule,
    DistributionDozModule,
    JsonPipe,
    MedIconCalendarEditModule,
    MedIconEditModule,
    MedIconCheckModule,
    MedIconRedoModule,
    MedIconCircleSlashModule,
  ],
  exports: [
    OrganizationsComponent,
    ReservesComponent,
  ],
})
export class LogisticComponentsModule {}
